import type { BarColors } from '@ui-kit/components/Bars/TopBar/types'
import type { Color } from '@ui-kit/types'

const mapBgColorToTypoColor: Record<BarColors, Color> = {
  grey100: 'deepForest',
  grey200: 'black',
  warningLight: 'warning',
  errorLight: 'error',
  playground4Light: 'playground4Dark',
  paleSpring: 'deepForest',
  successLight: 'success',
  grey300: 'grey700',
  black: 'white',
  uiGreenOverlay: 'uiGreenOverlay',
  brandLime: 'brandDark',
}

export const getFontColor = (bgColor?: BarColors): Color =>
  (bgColor && mapBgColorToTypoColor[bgColor]) || 'playground4Dark'
